export const UPDATE_REPORT_FORMAT = 'UPDATE_REPORT_FORMAT';

export const updateReportFormat = (format) => ({
    type: UPDATE_REPORT_FORMAT,
    payload: format
});



// WEBPACK FOOTER //
// ./components/sub-heading/format-picker/format-picker-actions.js